import React, { useState } from 'react';
import { Button, Checklist } from '@hexure/ui';

const LimitProductTypes = ({ mobile_app, updateAgencyMobileApp }) => {
  const all_product_types = [
    'Fixed Annuity',
    'Fixed Indexed Annuity',
    'Multi-Year Guaranteed Annuity'
  ];

  const [data, setData] = useState({
    annuity_product_types: mobile_app?.annuity_product_types || []
  });

  const handleChecklistChange = e => {
    setData({ ...data, annuity_product_types: e.target.value });
  };

  const save = () => {
    updateAgencyMobileApp(data);
  };

  return (
    <>
      <div style={{ marginBottom: 30 }}>
        <Checklist
          onChange={handleChecklistChange}
          options={all_product_types.map(pt => ({ value: pt }))}
          selected={data.annuity_product_types || []}
        />
      </div>

      <Button disabled={!data.annuity_product_types.length} onClick={save}>
        Save Changes
      </Button>
    </>
  );
};

export default LimitProductTypes;
